import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { statusSchedule } from 'app/core/data/calendar.json';
import { scheduleI, scheduleStatus } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { LayoutService } from 'app/core/http/services/layout.service';
import { AuthService } from 'app/core/http/services/auth.service';

@Component({
  selector: 'page-schedule-edit-status',
  templateUrl: './schedule-edit-status.component.html',
  styleUrls: ['./schedule-edit-status.component.scss']
})
export class ScheduleEditStatusComponent implements OnInit {

  public status = "planned";
  public scheduleStatus:scheduleStatus[] = statusSchedule;
  public schedule: scheduleI = <scheduleI>{};

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    public layout: LayoutService,
    private auth: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
    if (this.data.param.schedule) {
      this.schedule = this.data.param.schedule;
      this.status = this.schedule.status ? this.schedule.status : this.status;      
    }
  }

  saveStatus() {
    //@TODO PUT backend
    this.schedule.status = this.status;
    this.auth.updateLocalStorageById('schedules',this.schedule.id as number, this.schedule);
    this.dialogRef.close();
  }

}
